import { useCallback, useContext } from 'react';
import { useSelector } from 'react-redux';
import Raven from 'raven-js';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import UITourStep from 'ui-shepherd-react/tour/UITourStep';
import UITourNextButton from 'ui-shepherd-react/button/UITourNextButton';
import { Text } from 'foundations-components/components/Text';
import { REP_OVERVIEW } from '../../../constants/Events';
import { EXISTING_USER_FMO_TOUR, FMO_TOUR_DROPDOWN_STEP, ONBOARDING_V2_TOUR, ONBOARDING_V2_TOUR_WITHOUT_ANALYZE } from '../../../constants/TourConstants';
import { trackCancelUITour, trackFinishUITour } from '../../../utils/usageTracker';
import { getIsDealStageView } from '../../../selectors/forecastSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const TOUR_NOT_STARTED = 'not-started';
const ForecastSelectorTourStep = ({
  children
}) => {
  const getTourStepContent = tourKey => {
    switch (tourKey) {
      case EXISTING_USER_FMO_TOUR:
        return ['tour.existing.migrationTour.viewMoreStep.title', 'tour.existing.migrationTour.viewMoreStep.body'];
      case ONBOARDING_V2_TOUR:
      case ONBOARDING_V2_TOUR_WITHOUT_ANALYZE:
        return ['tour.onboardingV2.viewMoreStep.title', 'tour.onboardingV2.viewMoreStep.body'];
      default:
        {
          Raven.captureMessage('Unhandled tourKey in ForecastSelectorTourStep component', {
            extra: {
              tourKey
            }
          });
          return ['', ''];
        }
    }
  };
  const {
    tour
  } = useContext(TourContext);
  const isDealStageView = useSelector(getIsDealStageView);
  const handleBeforeNext = useCallback(() => {
    trackFinishUITour(FMO_TOUR_DROPDOWN_STEP, REP_OVERVIEW, isDealStageView);
  }, [isDealStageView]);
  const handleCancelTour = useCallback(() => {
    trackCancelUITour(FMO_TOUR_DROPDOWN_STEP, REP_OVERVIEW, isDealStageView);
  }, [isDealStageView]);
  const tourKey = tour.getTour();
  const tourStep = tour.getStep();
  if (!tourKey || tourStep === TOUR_NOT_STARTED) {
    return children;
  }
  const [title, body] = getTourStepContent(tourKey);
  return /*#__PURE__*/_jsx(UITourStep, {
    tourKey: tourKey,
    stepKey: FMO_TOUR_DROPDOWN_STEP,
    showSteps: true,
    placement: "bottom",
    showCloseButton: true,
    onClickCloseButton: handleCancelTour,
    content: {
      header: /*#__PURE__*/_jsx(Text, {
        as: "h4",
        color: "text-primary-on-fill-default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: title
        })
      }),
      body: /*#__PURE__*/_jsx(FormattedMessage, {
        message: body
      }),
      footer: /*#__PURE__*/_jsx(UIButtonWrapper, {
        children: /*#__PURE__*/_jsx(UITourNextButton, {
          beforeNext: handleBeforeNext,
          use: "primary",
          size: "small"
        })
      })
    },
    children: children
  });
};
export default ForecastSelectorTourStep;